import { IMetricsContent } from "src/share/types/alert";

export interface IChildrenStatistics {
    total: number,
    avgDays: number;
    avgAge: number;
};
export interface ICaseStatistics {
    open: number;
    closed: number;
    openAging: number;
    avgChildrenOC: number;
    openWA: number;
    newYTD: number;
    solvedYTD: number;
    avgDays: number;
};
export interface ISexStatistics {
    name: 'Male' | 'Female' | 'Not Specified' | string,
    count: number;
}
export interface IYearStatistics {
    opened: number,
    closed: number
    year: number;
}
export interface IAbductorStatistics {
    type: string,
    count: number;
}

export interface IMissingCity {
    type: string,
    count: number;
}

export interface IMissingCountry {
    type: string,
    count: number
}

export interface ICaseType {
    type: string,
    count: number;
}
export interface ICasesByWeek {
    type: string,
    count: number;
}

export interface IAgencyMetrics {
    caseMetrics: ICaseStatistics,
    childrenMetrics: IChildrenStatistics,
    sexMetrics: ISexStatistics[],
    yearMetrics: IYearStatistics[],
    abductorMetrics: IAbductorStatistics[],
    closeReasons: IMetricsContent[],
    date?: number,
    missingCity: IMissingCity[],
    caseType: ICaseType[],
    missingCountry: IMissingCountry[],
    casesByWeek: ICasesByWeek[]

};

export const initialAgencyMetrics = {
    caseMetrics: {
        open: 0, closed: 0, openAging: 0, avgChildrenOC: 0, openWA: 0, newYTD: 0, solvedYTD: 0, avgDays: 0
    },
    childrenMetrics: {
        total: 0,
        avgDays: 0,
        avgAge: 0
    },
    closeReasons: [],
    sexMetrics: [],
    abductorMetrics: [],
    yearMetrics: [],
    missingCity: [],
    caseType: [],
    missingCountry: [],
    casesByWeek: []
}
export const initialSex: ISexStatistics[] = [
    { name: 'Male', count: 0 },
    { name: 'Female', count: 0 },
    { name: 'Unknown', count: 0 }
]
export const testYearMetrics = [
    { opened: 4, closed: 1, year: 2018 },
    { opened: 1, closed: 3, year: 2017 },
    { opened: 4, closed: 2, year: 2014 },
    { opened: 2, closed: 4, year: 2011 }
]
export const testSexMetrics: ISexStatistics[] = [
    { name: 'Male', count: 10 },
    // { name: 'Female', count: 12 },
    // { name: 'Not Specified', count: 1 }
]
export const testAbductorMetrics: IAbductorStatistics[] = [
    { "type": "Abductor", "count": 10 },
    { "type": "Companion", "count": 8 },
    { "type": "Family Acquaintance", "count": 11 },
    { "type": "Father", "count": 1 },
    { "type": "Mother", "count": 13 },
    { "type": "Relative", "count": 1 },
    { "type": "Unknown", "count": 1 }, { "type": "Witness", "count": 12 }
]
export const IChildreRow = {
    total: 'Total Missing Children',
    avgDays: 'Avg Days Missing',
    avgAge: 'Avg Age Now'
};
export const ICaseRow = {
    open: 'Open Cases',
    openAging: 'Open Cases Aging (days)',
    avgChildrenOC: 'Avg Children in Open Cases',
    openWA: 'Open Cases with Abductos',
    newYTD: 'New Cases YTD',
    solvedYTD: 'Solved Cases YTD',
    avgDays: 'Avg Days to Solve a Case'
};  


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Home/types.tsx